import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import projectThunks from "../../config/thunks/businessDevAndPartnerships/projects/projects.thunks";
import ProjectsActualExpenditureGraph from "../../components/Home/ProjectsActualExpenditureGraph";
import ProjectsPieChart from "../../components/Home/ProjectPieChart";
import { Alert, Col, Row, Spin } from "antd";
import dashboardThunks from "../../config/thunks/dashboard/dashboard.thunks";
import StaffContacts from "../../components/Home/dashboard/StaffContacts";
import { isEmpty } from "lodash";
import DashboardCards from "./DashboardCards";
import TimeSheetDashboard from "./TimeSheetDashboard";
import CashbookSummary from "./CashbookSummary";
import TImeSheetCards from "./TimeSheetDashboard/TImeSheetCards";
import StrategicPlanDashboard from "./StrategicPlan";

const Dashboard = () => {
  const dispatch = useDispatch();
  const {
    projectsGraphDataLoading,
    projectsGraphDataError,
    projectsGraphDataSuccess,
  } = useSelector((state) => state.projectsState);
  const {
    dashboardDataLoading,
    dashboardDataSuccess,
    dashboardDataError,
    dashboardData,
  } = useSelector((state) => state.dashboardState);
  useEffect(() => {
    document.title = "DASHBOARD";
    if (!projectsGraphDataSuccess)
      dispatch(projectThunks.getProjectsGraphData());
    if (!dashboardDataSuccess) dispatch(dashboardThunks.getDashBoardData());
  }, [dispatch, projectsGraphDataSuccess, dashboardDataSuccess]);

  return (
    <div className="container-fluid">
      <h5 className="my-2">DASHBOARD</h5>
      {dashboardDataLoading && isEmpty(dashboardDataSuccess) ? (
        <div className="d-flex justify-content-center m-5">
          <Spin size="large" />
        </div>
      ) : (
        <div className="d-flex">
          {dashboardDataSuccess ? (
            <div className="w-100">
              <DashboardCards />
              <StrategicPlanDashboard />
              <CashbookSummary />
              <Row gutter={4} className="mb-3">
                <Col md={12}>
                  <TimeSheetDashboard />
                </Col>
                <Col md={12}>
                  <TImeSheetCards />
                </Col>
              </Row>

              <div>
                {projectsGraphDataLoading ? (
                  <div className="d-flex justify-content-center m-5">
                    <Spin size="large" />
                  </div>
                ) : (
                  <div>
                    {projectsGraphDataSuccess ? (
                      <Row gutter={4}>
                        <Col md={16} sm={24} xs={24} lg={16}>
                          <ProjectsActualExpenditureGraph />
                        </Col>
                        <Col md={8} sm={24} xs={24} lg={8}>
                          <ProjectsPieChart />
                        </Col>
                      </Row>
                    ) : (
                      <Alert
                        showIcon
                        type="error"
                        message={projectsGraphDataError}
                      />
                    )}
                  </div>
                )}
                <StaffContacts data={dashboardData} />
              </div>
            </div>
          ) : (
            <Alert showIcon message={dashboardDataError} type="error" />
          )}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
